module.exports = __webpack_public_path__ + "media/images/team/Thorsten-6641b7ad28efa2f513b4e7fe831686fb.jpg";